import { useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase";
import ReactHtmlParser from "react-html-parser";

const SinglePostPage = () => {
  const [blog, setBlog] = useState();
  const { id } = useParams();
  const docRef = db.collection("blogs/blog/posts").doc(id);
  docRef
    .get()
    .then((doc) => {
      if (doc.exists) {
        var storedDate = new Date(doc.data().createdate.toDate());
        var nowDate = new Date();
        var elapsedTime = nowDate.getTime() - storedDate.getTime();
        setBlog({ ...doc.data(), timeAgo: elapsedTime });
      } else {
        console.log("No such document!");
      }
    })
    .catch((error) => {
      console.log("Error getting document:", error);
    });

  if (blog) {
    return (
      <div className="SinglePostPage">
        <div className="hero">
          <img src={blog.file.src} alt="" />
          <div className="post-head">
            <h1>{blog.title}</h1>
            <h6 className="author-name"></h6>
            <p className="date">
              {Math.floor(blog.timeAgo / 1000 / 60 / 60 / 24) < 1
                ? "اليوم"
                : `منذ ${Math.floor(blog.timeAgo / 1000 / 60 / 60 / 24)} يوم`}
            </p>
          </div>
        </div>
        <div className="container">
          <div className="content">{ReactHtmlParser(blog.body)}</div>
        </div>
      </div>
    );
  } else {
    return <div className="loading"></div>;
  }
};

export default SinglePostPage;
